import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { AuthProvider } from "./contexts/AuthContext";
import { PersonalityProvider } from "./contexts/PersonalityContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <AuthProvider>
      <PersonalityProvider>
        <App />
      </PersonalityProvider>
    </AuthProvider>
  </React.StrictMode>
);
